/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum LandscapeCommodityAvailabilityType {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
}
